// @file try_catch.ts Utility functions for error handling without try/catch blocks

// Uses https://github.com/asleepace/try, which is built by @asleepace (Colin Teahan)
// The package includes tests, etc... and it's by our own trusted engineer, so we can use it without hesitation
import { Try } from '@asleepace/try'

export const tryCatch = Try.catch
